import { Music, UtensilsCrossed, Sparkles, Wand2, ShieldCheck, Lightbulb } from "lucide-react";
import BackToMore from "../components/BackToMore";

// Each room is its own card — matches reference layout
const LOCATIONS = [
  {
    name: "Auditorium",
    icon: Music,
    color: "var(--primary)",
    iconColor: "white",
    lines: [
      "Morning of Line Dancing, D9 Strolling, Exercising, DJ, Music, and Entertainment (7:30–8:30 AM)",
      "Keynote: Dr. Adam Phyall (8:30–9:15 AM)",
    ],
  },
  {
    name: "Cafeteria",
    icon: UtensilsCrossed,
    color: "var(--gold)",
    iconColor: "var(--primary-dark)",
    lines: ["Lunch (11:45 AM–1:00 PM)"],
  },
  // Computer Labs (sorted A→Z, then by number)
  { name: "Computer Lab B117", icon: ShieldCheck, color: "var(--primary)", iconColor: "white", lines: ["Science Teachers - Gizmos"] },
  { name: "Computer Lab C148", icon: ShieldCheck, color: "var(--primary)", iconColor: "white", lines: ["Social Studies Teachers - Social Studies Curriculum Overview"] },
  { name: "Computer Lab C211", icon: ShieldCheck, color: "var(--primary)", iconColor: "white", lines: ["Non-Core Teachers - Schoology"] },
  { name: "Computer Lab C212", icon: ShieldCheck, color: "var(--primary)", iconColor: "white", lines: ["English Language Arts Teachers - Newsela"] },
  { name: "Computer Lab C214", icon: ShieldCheck, color: "var(--primary)", iconColor: "white", lines: ["Math Teachers - Magma Math"] },
  { name: "Computer Lab C229", icon: ShieldCheck, color: "var(--primary)", iconColor: "white", lines: ["MagicSchool AI & AI Prompting"] },
  { name: "Computer Lab C233", icon: ShieldCheck, color: "var(--primary)", iconColor: "white", lines: ["MagicSchool AI & AI Prompting"] },
  { name: "Computer Lab C240", icon: ShieldCheck, color: "var(--primary)", iconColor: "white", lines: ["MagicSchool AI & AI Prompting"] },
  { name: "Computer Lab Science Lab", icon: ShieldCheck, color: "var(--primary)", iconColor: "white", lines: ["MagicSchool AI & AI Prompting"] },
  // AI in Middle Schools rooms
  { name: "Room C205", icon: Sparkles, color: "var(--maroon)", iconColor: "white", lines: ["AI in Middle Schools"] },
  { name: "Room C206", icon: Sparkles, color: "var(--maroon)", iconColor: "white", lines: ["AI in Middle Schools"] },
  { name: "Room C207", icon: Sparkles, color: "var(--maroon)", iconColor: "white", lines: ["AI in Middle Schools"] },
  { name: "Room C208", icon: Sparkles, color: "var(--maroon)", iconColor: "white", lines: ["AI in Middle Schools"] },
];

export default function Locations() {
  return (
    <div
      style={{ padding: "16px", paddingBottom: "40px" }}
      data-testid="locations-page"
    >
      <BackToMore />
      <h2
        style={{
          fontSize: "22px",
          fontWeight: 800,
          color: "var(--primary-dark)",
          marginBottom: "4px",
        }}
      >
        Where to Go - Huffman High School
      </h2>
      <p
        style={{
          color: "var(--text-muted)",
          fontSize: "14px",
          marginBottom: "20px",
        }}
      >
        Every room and the sessions held there.
      </p>

      {LOCATIONS.map((loc) => {
        const Icon = loc.icon;
        return (
          <div
            key={loc.name}
            data-testid={`location-card-${loc.name}`}
            className="flex items-start shadow-card"
            style={{
              backgroundColor: "var(--surface)",
              borderRadius: "14px",
              padding: "14px",
              marginBottom: "12px",
              border: "1px solid var(--border)",
              gap: "14px",
            }}
          >
            <div
              className="flex items-center justify-center flex-shrink-0"
              style={{
                width: "52px",
                height: "52px",
                borderRadius: "14px",
                backgroundColor: loc.color,
              }}
            >
              <Icon size={26} color={loc.iconColor} strokeWidth={2} />
            </div>
            <div className="flex-1 min-w-0">
              <p
                style={{
                  fontSize: "18px",
                  fontWeight: 800,
                  color: "var(--primary-dark)",
                  lineHeight: "22px",
                  marginBottom: "6px",
                }}
              >
                {loc.name}
              </p>
              {loc.lines.map((line, i) => (
                <p
                  key={`${loc.name}-line-${i}-${line.slice(0, 20)}`}
                  style={{
                    color: "var(--text-muted)",
                    fontSize: "13px",
                    lineHeight: "19px",
                    marginTop: i === 0 ? 0 : "4px",
                  }}
                >
                  {line}
                </p>
              ))}
            </div>
          </div>
        );
      })}

      <div
        className="flex items-center"
        style={{
          backgroundColor: "#FDF4DC",
          padding: "14px",
          borderRadius: "12px",
          marginTop: "16px",
          gap: "10px",
        }}
      >
        <Lightbulb size={18} color="var(--gold)" style={{ flexShrink: 0 }} />
        <p
          className="flex-1"
          style={{
            color: "var(--primary-dark)",
            fontSize: "13px",
            lineHeight: "19px",
          }}
        >
          Tip: Check Group Rotation to see exactly where your group should be
          at each time slot.
        </p>
      </div>
    </div>
  );
}
